import Constants from '../../constants/index';
import { reducerMerger } from '../helpers/entities';
import { CommentRecord } from '../../records/index';
import { Map } from 'immutable';

export const DEFAULT_STATE = Map({});

export const comments = reducerMerger(
	[
		Constants.FETCH_QUESTION_LIST,
		Constants.FETCH_QUESTION,
		Constants.FETCH_QUESTION_RELATED,
		Constants.SEARCH_QUESTIONS,
		Constants.FETCH_ANSWERS,
		Constants.FETCH_ANSWER,
	],
	'comments',
	CommentRecord,
	DEFAULT_STATE,
);
